import api from 'api'

export type HttpServiceFactoryParam = {
  name: string
  type: string
  required: boolean
  choices?: string[]
}

export type HttpServiceGetEndpoint = {
  methodName: string
  urlPattern: string
  pathParams: string[]
  graphqlQuery?: string
  graphqlVariables?: string[]
}

export type HttpService = {
  name: string
  clientClass: string
  module: string
  factoryParams: HttpServiceFactoryParam[]
  getEndpoints: HttpServiceGetEndpoint[]
}

export type ListHttpServicesResponse = {
  services: HttpService[]
}

export const listHttpServices = async (): Promise<ListHttpServicesResponse> => {
  const result = await api.get<ListHttpServicesResponse>('/admin/http_services')
  return result.data
}
